/**
 * /admin/fic-reports/new — Create FIC report (route shell).
 * Screen impl in `./fic-reports.new-screen.tsx`, lazy-loaded.
 */

import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

export const Route = createFileRoute('/admin/fic-reports/new')({
  component: lazyRouteComponent(
    () => import('./fic-reports.new-screen'),
    'AdminFicReportNew',
  ),
});
